export const getDecimalNumbers = value => {
  return value ? value.split('.')[1] : undefined;
};